import {
  COMPLIANCE,
  ACCOUNTS_RECEIVABLE,
  MERCHANT_ACCOUNTS,
} from './constants';

export const SELF_EMPLOYMENT_INITIAL = {
  businessEIN: '',
  noEIN: false,
  nameOfBusiness: '',
  numberOfEmployees: 0,
  typeOfBusiness: '',
};

export default {
  [COMPLIANCE]: false,
  [ACCOUNTS_RECEIVABLE]: [],
  [MERCHANT_ACCOUNTS]: [],
  selfEmployment: { ...SELF_EMPLOYMENT_INITIAL },
  initialCompliance: null,
  initialBusinessInfo: null,
};
